import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Columns from "./TableColumns";
import Rows from "./TableRows";
import { Add } from "@mui/icons-material";
import { merge, cloneDeep } from "lodash";
import { generateUUID, showToast } from "services/utils";
import { useNavigate } from "react-router-dom";
import AlertOnBackNavigation from "../Components/AlertOnBackNavigation";
import { hasNonEmptyObject } from "../services";

const CustomeTable = (props) => {
  const {
    rows,
    config = [],
    columns,
    isLoading,
    defaultValue = false,
  } = props.data;
  const { userData, selectedRole } = props;

  let defaultConfig = {
    // onDelete: {
    //     before: false,
    //     after: false,
    // },
    onDelete: false,
    isImageinLink: false,
    // onSubmit: false,
    // addRow: false,
    // addRow: true,
    addRow: {
      isVisible: true,
      isActive: true,
    },
    onSubmit: false,
    isId: true,
    checkEsignById: false,
    // onSubmit: {
    //     checkESign: true,
    //     // type: "row",
    //     type: "table",
    //     handler: handleSubmit,
    //     checkValidation: true,
    //     isVisible : true,
    //     isActive : true
    //     // before : false,
    //     // after : false
    //     // before : {
    //     //     checkValidation : true,
    //     //     handler : (openFn) => { openFn() }
    //     // }
    // },
    onESign: false,
    // onESign: {
    //     before: {
    //         checkValidation: true,
    //         handler: (handleModelOpen) => {
    //             handleModelOpen()
    //         }
    //     },
    //     // before: false,
    //     // afterESign: false,
    // },
    // validation: {
    //     beforeValidation: false,
    //     afterValidation: false,
    // },
    isDayOff: {
      uniqueName: false,
      isCheck: false,
    },
    // isStatic: true,
    isViewMode: false,
    multipleESign: false,
    // multipleESign: {
    //     format: ["first", "second"],
    //     // start : "second"
    //     start: 0
    // },
    // renderOptions : {
    //     specific : "rows", // all, rows, columns
    //     type : "single", // single
    // }
    // actions: [
    //     {
    //         tooltip : "View document",
    //         name: "view",
    //         icon: <Eye/>,
    //         color: "error",
    //         onClick: () => { },
    //         isVisible : false,
    //         isActive : true
    //     }
    // ],
    actions: false,
    renderOptions: false,
    dependencyFields: false,
    // dependencyFields: {
    //     endTime: {
    //         type: 'all',
    //         // effectOn: ["downTimeDuration"],
    //         // handler: (data) => { },
    //         handler: (data) => {
    //             /*
    //                 perforn any operation and return final value.
    //                 make sure the return value is same as column type
    //             */
    //             return ({
    //                 downTimeDuration: "18 : 20"
    //             })
    //         }
    //     }
    // },
    title: false,
    // title: {
    //     defaultTableName: "testTable",
    //     name: "Test Table",
    //     isVisible: true,
    // },
    chip: {
      // uniqueName: {
      //     color: "",
      //     varient: "",
      //     label: "",
      //     onClick: () => { }
      // },
      // reviewedBy: generateChipConfig
      // (data) => {
      //     /*
      //         clog data = {
      //             row,
      //             column,
      //         }
      //     */
      // }
    },
    navLink: false,
    // navLink: {
    //     breakdownReason: (data) => {
    //         return ({
    //             id : "684d37f7e7eb7998d2cd8b89"
    //         })
    //     }
    // },
    onScroll: false,
    dynamicOptions: false,
    // dynamicOptions: {
    //   //  uniqueName : [ ...options ],
    //   machineName: ["machine-11", "machine-22", "machine-33", "machine-44"],
    //   machineName: {
    //     isUnique: true,
    //     options: ["machine-11", "machine-22", "machine-33", "machine-44"]
    //   },
    // }
    dynamicOptionsByRows: false,
    modifyData: false,
    // modifyData: {
    //   select: {
    //     type: "row",
    //     handler: (data, allData) => {
    //       const { row } = data
    //       if (row?.select) {
    //         allData?.columns?.forEach((col) => {
    //           if (col.uniqueName === "quantity") {
    //             col.isReadOnly = false
    //           }
    //         })
    //       } else if (!row?.select) {
    //         allData?.columns?.forEach((col) => {
    //           if (col.uniqueName === "quantity") {
    //             col.isReadOnly = true
    //           }
    //         })
    //       }
    //       return ({
    //         quantity: true,
    //       })
    //     }
    //   }
    // },
    wrapperSupport: false,
  };

  defaultConfig = merge(defaultConfig, { ...config, userData, selectedRole });

  const [_, forceUpdate] = useState({});
  const render = () => forceUpdate({});
  let rowsErrorRef = useRef({});
  const ref = useRef();
  const navigate = useNavigate();
  const helperRef = useRef({
    dataModify: false,
    rowByOptions: Array.from({ length: rows?.length }, () => ({})),
    optionsUniqueness: {
      availableOptions: {},
      rowsOptions: Array.from({ length: rows?.length }, () => ({})),
    },
    dynamicType: Array.from({ length: rows?.length }, () => ({})),
    trackChanges: Array.from({ length: rows?.length }, () => ({})),
    dynamicReadableRef: Array.from({ length: rows?.length }, () => ({})),
  });

  const addNewRow = () => {
    if (defaultValue === false) {
      const newRow = columns?.reduce(
        (acc, column) => {
          if (column?.uniqueName?.includes("srNo")) {
            return acc;
          } else if (Object.hasOwn(column, "options")) {
            return (acc = { ...acc, [column?.uniqueName]: "" });
          } else {
            return (acc = { ...acc, [column?.uniqueName]: "" });
          }
        },
        {
          isNew: true,
          id: defaultConfig?.isId ? generateUUID() : "",
          ...(defaultConfig?.multipleESign !== false
            ? {
                currentESignStep:
                  typeof defaultConfig?.multipleESign?.start === "number"
                    ? defaultConfig?.multipleESign?.format[
                        defaultConfig?.multipleESign?.start
                      ]
                    : defaultConfig?.multipleESign?.start,
              }
            : null),
        }
      );
      rows.push(newRow);
    } else {
      rows.push(defaultValue);
    }
    helperRef.current.rowByOptions.push({});
    helperRef.current.dynamicType.push({});
    helperRef.current.trackChanges.push({});
    helperRef.current.optionsUniqueness.rowsOptions.push({});
    helperRef.current.dynamicReadableRef.push({});
    renderRef.current.rowsRender.rows.push([() => {}, {}]);
    renderRef.current.rowsRender.allRows();

    // if (ref.current?.scrollHeight) {
    //   setTimeout(() => {
    //     ref.current.scrollTop = ref.current.scrollHeight;
    //   }, 0);
    // }
    if (ref.current) {
      setTimeout(() => {
        if (ref.current) {
          ref.current.scrollTop = ref?.current?.scrollHeight;
        }
      }, 0);
    }
  };

  const handleSubmit = () => {
    let errors = null;
    if (
      defaultConfig?.onSubmit !== false &&
      defaultConfig?.onSubmit?.checkValidation === true
    ) {
      errors = {};
      const dynamicReadableRef = helperRef.current.dynamicReadableRef;
      rows?.forEach((row, rowIndex) => {
        columns.forEach((column) => {
          if (Object.hasOwn(column, "validation")) {
            const { required, msg } = column?.validation;
            if (required) {
              if (
                defaultConfig?.multipleESign !== false &&
                row?.currentESignStep !== column?.eSignStep
              ) {
                return;
              }

              const isValidate = dynamicReadableRef?.[rowIndex]?.[
                column?.uniqueName
              ]
                ? true
                : row?.[column?.uniqueName] &&
                  typeof row?.[column?.uniqueName] === "string"
                ? row?.[column?.uniqueName]?.length > 0
                : [null, undefined].includes(row?.[column?.uniqueName])
                ? false
                : Object.keys(row?.[column?.uniqueName])?.length > 0;

              if (isValidate && Object.hasOwn(column.validation, "pattern")) {
                const { pattern, patternMsg } = column?.validation;
                const parts = pattern.match(/^\/(.*)\/([gimsuy]*)$/);
                const matchPattern = parts ? parts[1] : pattern;
                const flags = parts?.[2] || "";
                const regex = new RegExp(matchPattern, flags);
                const isValid = regex.test(row?.[column?.uniqueName]);
                !isValid
                  ? (errors[rowIndex] = {
                      ...errors[rowIndex],
                      ...{
                        [column.uniqueName]: {
                          error: true,
                          msg: patternMsg,
                        },
                      },
                    })
                  : null;
              } else {
                !isValidate
                  ? (errors[rowIndex] = {
                      ...errors[rowIndex],
                      ...{
                        [column.uniqueName]: {
                          error: true,
                          msg: msg,
                        },
                      },
                    })
                  : null;
              }
            }
          }
        });
      });
    }
    if (errors !== null && Object.keys(errors)?.length > 0) {
      rowsErrorRef.current = errors;
      renderRef.current.rowsRender.allRows();
      showToast("Error in table inputs !", false);
      return false;
    }
    const cloneTrackChanges = cloneDeep(helperRef.current?.trackChanges);
    const cloneRows = cloneDeep(rows);

    !defaultConfig?.wrapperSupport &&
      defaultConfig?.onSubmit?.handler &&
      defaultConfig?.onSubmit?.handler(cloneRows, cloneTrackChanges);
    helperRef.current.trackChanges = rows.map(() => ({}));
    return {
      rows: cloneRows,
      trackChanges: cloneTrackChanges,
    };
  };

  const renderRef = useRef({
    table: render,
    columnsRender: {
      allColumns: () => {},
      columns: Array.from(
        {
          length:
            defaultConfig?.actions !== false
              ? columns?.length + 1
              : columns?.length,
        },
        () => ({})
      ),
    },
    rowsRender: {
      allRows: () => {},
      rows: Array.from({ length: rows?.length }, () => [() => {}, {}]),
    },
  });

  if (
    defaultConfig?.dynamicOptions !== false &&
    Object.keys(defaultConfig?.dynamicOptions).length > 0
  ) {
    const dynamicOptionKeys = Object.keys(defaultConfig.dynamicOptions);

    columns?.forEach((column) => {
      if (dynamicOptionKeys.includes(column?.uniqueName)) {
        const dynamicOptions = defaultConfig.dynamicOptions[column.uniqueName];

        if (!column?.uniqueOptions) {
          column.options = dynamicOptions;
        } else {
          if (!helperRef.current.optionsUniqueness?.availableOptions) {
            helperRef.current.optionsUniqueness.availableOptions = {};
          }

          helperRef.current.optionsUniqueness.availableOptions[
            column.uniqueName
          ] = dynamicOptions;
        }
      }
    });
  }

  if (rows?.length === 0 && !defaultConfig?.isViewMode) {
    !defaultConfig?.isViewMode ? addNewRow() : null;
  }

  const handlerCancel = () => {
    navigate(-1);
  };

  if (!!defaultConfig?.onSubmit?.getSubmitHandler !== false) {
    defaultConfig?.onSubmit?.getSubmitHandler(handleSubmit, config);
  }

  if (!!defaultConfig?.dynamicType?.default) {
    rows?.forEach((row, rowIndex) => {
      columns.forEach((column, columnIndex) => {
        const passCurrentData = {
          row,
          rowIndex,
          column,
          columnIndex,
        };
        const newTypeForRow = defaultConfig?.dynamicType.default[
          column?.uniqueName
        ]
          ? defaultConfig?.dynamicType.default[column?.uniqueName](
              passCurrentData
            )
          : {};

        if (!helperRef.current.dynamicType[rowIndex]) {
          helperRef.current.dynamicType[rowIndex] = {};
        }

        Object.keys(newTypeForRow).forEach((key) => {
          helperRef.current.dynamicType[rowIndex][key] = newTypeForRow[key];
        });
      });
    });
  }

  let columnType = config?.columnType || "static";

  const getGroupedHeaders = (columns) => {
    const levels = [];
    let maxDepth = 0;

    for (const col of columns) {
      const path = col.groupPath || [];
      maxDepth = Math.max(maxDepth, path.length);

      // Build group headers
      path.forEach((label, levelIndex) => {
        if (!levels[levelIndex]) levels[levelIndex] = new Map();

        const groupKey = path.slice(0, levelIndex + 1).join(">");
        if (!levels[levelIndex].has(groupKey)) {
          levels[levelIndex].set(groupKey, {
            label,
            colSpan: 0,
            rowSpan: 1,
          });
        }
      });

      // Add leaf (final column header)
      const levelIndex = path.length;
      if (!levels[levelIndex]) levels[levelIndex] = new Map();

      const colKey = col.uniqueName;
      levels[levelIndex].set(colKey, {
        label: col.name,
        colSpan: 1,
        rowSpan: 1,
      });

      // Increment colSpans upwards
      for (let i = path.length - 1; i >= 0; i--) {
        const groupKey = path.slice(0, i + 1).join(">");
        const group = levels[i].get(groupKey);
        if (group) group.colSpan += 1;
      }
    }

    // Add ungrouped columns (like Lot Size) to top level with full row span
    columns.forEach((col) => {
      if (!col.groupPath || col.groupPath.length === 0) {
        if (!levels[0]) levels[0] = new Map();
        const key = col.uniqueName;
        levels[0].set(key, {
          label: col.name,
          colSpan: 1,
          rowSpan: maxDepth + 1, // span all header rows
        });
      }
    });

    return levels.map((level) => Array.from(level.values()));
  };

  if (
    !!defaultConfig?.getTrackChanges &&
    typeof defaultConfig?.getTrackChanges === "function"
  ) {
    defaultConfig.getTrackChanges(helperRef.current.trackChanges);
  }

  const finalConfig = {
    ...defaultConfig,
    rows,
    columns,
    helperRef,
    rendersRows: renderRef?.current?.rowsRender,
    renderTable: renderRef?.current?.table,
    rowByOptions: helperRef.current.rowByOptions,
    optionsUniqueness: helperRef?.current?.optionsUniqueness,
    dynamicTypeRef: helperRef.current.dynamicType,
    dynamicReadableRef: helperRef.current.dynamicReadableRef,
    trackChanges: helperRef.current?.trackChanges,
  };

  // props.data.config["[**globalConfig**]"] = cloneDeep(finalConfig)
  props.data.config["GLOBAL_CONFIG"] = {
    config: finalConfig,
    SUBMIT_HANDLER: handleSubmit,
    REF: ref,
  };

  const { wrapperUtils = {}, syncing = {} } = finalConfig?.wrapperConfig ?? {
    wrapperUtils: {},
    syncing: {},
  };

  return (
    <>
      {/* {!defaultConfig?.wrapperSupport && (
        <AlertOnBackNavigation
          getModifyStatus={() => {
            return hasNonEmptyObject(helperRef.current?.trackChanges);
          }}
        />
      )} */}

      <Box>
        {defaultConfig?.title?.isVisible && (
          <Box
            sx={{
              margin: "50px 0px 20px 0px",
            }}
          >
            <Typography variant="h5">{defaultConfig?.title?.name}</Typography>
          </Box>
        )}

        <TableContainer
          component={Paper}
          className="temp"
          sx={{ maxHeight: "80vh" }}
          onScroll={() => {
            !!wrapperUtils?.onScroller &&
              wrapperUtils.onScroller(finalConfig.title.defaultTableName);
          }}
          ref={ref}
        >
          <Table aria-label="simple table" stickyHeader>
            {finalConfig?.columnsHide ? null : (
              <TableHead
                sx={{
                  position: "sticky",
                  top: "0",
                  bgcolor: "#fff",
                  zIndex: 1000,
                }}
              >
                <Columns
                  columns={columns}
                  renders={renderRef?.current?.columnsRender}
                  config={{
                    ...defaultConfig,
                    columns,
                    reRenders: renderRef?.current?.columnsRender,
                    renderTable: renderRef?.current?.table,
                    getGroupedHeaders,
                  }}
                />
              </TableHead>
            )}

            <TableBody
              sx={{
                border: "1px solid red",
                height: "10vh",
              }}
            >
              {!!defaultConfig?.isViewMode && rows?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={columns?.length} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              ) : (
                <Rows
                  rows={rows}
                  columns={columns}
                  renders={renderRef?.current?.rowsRender}
                  config={finalConfig}
                  errorRef={rowsErrorRef}
                />
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {!defaultConfig?.isViewMode ? (
          <Box
            sx={{
              margin: "20px 0px",
              display: "flex",
              justifyContent: !!defaultConfig?.addRow?.isVisible
                ? "space-between"
                : "end",
              gap: "10px",
              width: "100%",
            }}
          >
            {!!defaultConfig?.addRow !== false &&
              defaultConfig?.addRow?.isVisible && (
                <Button
                  variant="contained"
                  startIcon={<Add />}
                  onClick={addNewRow}
                  disabled={!!!defaultConfig?.addRow?.isActive}
                >
                  Add
                </Button>
              )}

            {
              // !defaultConfig?.wrapperSupport && (
              (!!defaultConfig?.wrapperSupport ? !syncing?.submits : true) && (
                <Box
                  sx={{
                    display: "flex",
                    gap: "20px",
                  }}
                >
                  {!!defaultConfig?.onCancel !== false &&
                    !!defaultConfig?.onCancel?.isVisible && (
                      <Button
                        variant="contained"
                        color="error"
                        disabled={!defaultConfig?.onCancel?.isActive ?? false}
                        onClick={
                          !!defaultConfig?.onCancel?.handler
                            ? defaultConfig?.onCancel?.handler
                            : handlerCancel
                        }
                      >
                        Cancel
                      </Button>
                    )}
                  {defaultConfig?.onSubmit !== false &&
                  defaultConfig?.onSubmit?.isVisible &&
                  defaultConfig?.onSubmit?.type === "table" ? (
                    <Button
                      disabled={!defaultConfig?.onSubmit?.isActive}
                      variant="contained"
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  ) : null}
                </Box>
              )
            }
          </Box>
        ) : null}
      </Box>
    </>
  );
};

export default CustomeTable;
